import { combineReducers } from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'
import workSpace from './workSpace/workSpaceSlice'
import connector from './connector/connectorSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        base,
        workSpace,
        connector,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
